<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable prettier/prettier -->
<template>
  <v-container v-if="planDataIsRetrieved">
    <v-tabs grow>
      <v-tab>Oppsett</v-tab>
      <v-tab-item class="mt-3">
        <v-tabs>
          <v-tab ripple>Beskrivelser</v-tab>
          <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_evaluering }}</v-tab>
          <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_activities }}</v-tab>
          <v-tab ripple>{{GET_ORDLYD && GET_ORDLYD.org_area_activities}}</v-tab>
          <v-tab ripple>Vernerundespørsmål</v-tab>

          <v-tab-item>
            <h1>Plantittel</h1>

            <v-text-field
              label="Periode"
              @input="registeredchanges = true"
              v-model="plan.planning.year"
              type="number"
            ></v-text-field>
            <v-text-field
              box
              v-model="planTitle"
              solo
              flat
              @input="registeredchanges = true"
            ></v-text-field>
            <h1>Beskrivelse av plan</h1>
            <pre v-text="planDescription"></pre>
            <editor-menu-bar
              :editor="planEditors.planDescription"
              v-slot="{ commands, isActive, focused }"
            >
              <div class="menubar is-hidden" :class="{ 'is-focused': focused }">
                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bold() }"
                  @click="commands.bold"
                >
                  <v-icon>format_bold</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 1 }) }"
                  @click="commands.heading({ level: 1 })"
                  >Overskrift 1</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 2 }) }"
                  @click="commands.heading({ level: 2 })"
                  >Overskrift 2</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 3 }) }"
                  @click="commands.heading({ level: 3 })"
                  >Overskrift 3</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bullet_list() }"
                  @click="commands.bullet_list"
                >
                  <v-icon>format_list_bulleted</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.ordered_list() }"
                  @click="commands.ordered_list"
                >
                  <v-icon>format_list_numbered</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.undo">
                  <v-icon>undo</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.redo">
                  <v-icon>redo</v-icon>
                </v-btn>

                <!-- <v-btn class="menubar__button" @click="saveContent">
              <v-icon>save</v-icon>
                </v-btn>-->
              </div>
            </editor-menu-bar>
            <editor-content :editor="planEditors.planDescription" />
            <h1>Veiledning</h1>
            <editor-menu-bar
              :editor="planEditors.planVeiledning"
              v-slot="{ commands, isActive, focused }"
            >
              <div class="menubar is-hidden" :class="{ 'is-focused': focused }">
                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bold() }"
                  @click="commands.bold"
                >
                  <v-icon>format_bold</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 1 }) }"
                  @click="commands.heading({ level: 1 })"
                  >Overskrift 1</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 2 }) }"
                  @click="commands.heading({ level: 2 })"
                  >Overskrift 2</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 3 }) }"
                  @click="commands.heading({ level: 3 })"
                  >Overskrift 3</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bullet_list() }"
                  @click="commands.bullet_list"
                >
                  <v-icon>format_list_bulleted</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.ordered_list() }"
                  @click="commands.ordered_list"
                >
                  <v-icon>format_list_numbered</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.undo">
                  <v-icon>undo</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.redo">
                  <v-icon>redo</v-icon>
                </v-btn>
              </div>
            </editor-menu-bar>
            <editor-content :editor="planEditors.planVeiledning" />

            <h1>{{ GET_ORDLYD && GET_ORDLYD.desc_main_target }}</h1>
            <editor-menu-bar
              :editor="planEditors.planOverordnaMaal"
              v-slot="{ commands, isActive, focused }"
            >
              <div class="menubar is-hidden" :class="{ 'is-focused': focused }">
                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bold() }"
                  @click="commands.bold"
                >
                  <v-icon>format_bold</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 1 }) }"
                  @click="commands.heading({ level: 1 })"
                  >Overskrift 1</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 2 }) }"
                  @click="commands.heading({ level: 2 })"
                  >Overskrift 2</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 3 }) }"
                  @click="commands.heading({ level: 3 })"
                  >Overskrift 3</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bullet_list() }"
                  @click="commands.bullet_list"
                >
                  <v-icon>format_list_bulleted</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.ordered_list() }"
                  @click="commands.ordered_list"
                >
                  <v-icon>format_list_numbered</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.undo">
                  <v-icon>undo</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.redo">
                  <v-icon>redo</v-icon>
                </v-btn>

                <!-- <v-btn class="menubar__button" @click="saveContent">
              <v-icon>save</v-icon>
                </v-btn>-->
              </div>
            </editor-menu-bar>
            <editor-content :editor="planEditors.planOverordnaMaal" />
            <h1>{{ GET_ORDLYD && GET_ORDLYD.desc_avdeling_target }}</h1>
            <editor-menu-bar
              :editor="planEditors.planAvdMaal"
              v-slot="{ commands, isActive, focused }"
            >
              <div class="menubar is-hidden" :class="{ 'is-focused': focused }">
                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bold() }"
                  @click="commands.bold"
                >
                  <v-icon>format_bold</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 1 }) }"
                  @click="commands.heading({ level: 1 })"
                  >Overskrift 1</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 2 }) }"
                  @click="commands.heading({ level: 2 })"
                  >Overskrift 2</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.heading({ level: 3 }) }"
                  @click="commands.heading({ level: 3 })"
                  >Overskrift 3</v-btn
                >

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.bullet_list() }"
                  @click="commands.bullet_list"
                >
                  <v-icon>format_list_bulleted</v-icon>
                </v-btn>

                <v-btn
                  flat
                  class="menubar__button"
                  :class="{ 'elevation-5': isActive.ordered_list() }"
                  @click="commands.ordered_list"
                >
                  <v-icon>format_list_numbered</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.undo">
                  <v-icon>undo</v-icon>
                </v-btn>

                <v-btn flat class="menubar__button" @click="commands.redo">
                  <v-icon>redo</v-icon>
                </v-btn>

                <!-- <v-btn class="menubar__button" @click="saveContent">
              <v-icon>save</v-icon>
                </v-btn>-->
              </div>
            </editor-menu-bar>
            <editor-content :editor="planEditors.planAvdMaal" />
          </v-tab-item>

          <v-tab-item>
            <h1>Evalueringsspørsmål</h1>
            <template v-for="evaluation in plan.evaluationtasks">
              <v-text-field
                box
                v-model="evaluation.question"
                :key="evaluation.id"
                append-icon="delete"
                @click:append="deleteEvaluationTask(evaluation)"
              ></v-text-field>
            </template>
            <v-text-field
              label="Legg til nytt spørsmål"
              box
              v-model="newEvaluation"
              append-icon="add"
              @click:append="addEvaluationTask"
            ></v-text-field>
          </v-tab-item>

          <v-tab-item>
            <h1>{{ GET_ORDLYD && GET_ORDLYD.main_overordna_activities }}</h1>
            <v-data-table :items="overordna_aktivitet" hide-actions>
              <template v-slot:headers>
                <tr>
                  <th align="left" style="width: 20%;">Tidsplan</th>
                  <th align="left" style="width: 15%;">Kategori</th>
                  <th align="left" style="width: 40%;">Tiltak</th>
                  <th align="left" style>Ansvarlig</th>
                  <th style="width:50px;"></th>
                </tr>
              </template>
              <template v-slot:items="props">
                <!-- <div>{{props.item}}</div> -->
                <tr>
                  <td>
                    <v-select
                      :items="maanedsvalg"
                      v-model="props.item.schedule"
                      @change="registeredchanges = true"
                    ></v-select>
                  </td>
                  <td>
                    <v-menu
                      v-model="props.item.kategori_meny"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ props.item.category || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="
                            props.item.category = item.category;
                            registeredchanges = true;
                          "
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.measure"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.responsibility"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td align="right">
                    <v-icon @click="fjern_aktivitet(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <th colspan="5">Legg til ny aktivitet</th>
                </tr>
                <tr>
                  <td>
                    <v-select
                      label="Tidsplan"
                      :items="maanedsvalg"
                      v-model="newSchedule"
                      @change="registeredchanges = true"
                    ></v-select>
                  </td>
                  <td>
                    <v-menu
                      v-model="newCategoryOverordnaAktivitetMeny"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ newCategoryOverordnaAktivitet || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="newCategoryOverordnaAktivitet = item.category"
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newMeasure"
                      label="Tiltak"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newResponsibility"
                      label="Ansvar"
                    ></v-text-field>
                  </td>
                  <td align="right">
                    <v-icon @click="legg_til_overordna_aktivitet">add</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <h1>
              {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_mandatory_activities }}
            </h1>
            <v-data-table :items="avd_aktivitet" hide-actions>
              <template v-slot:headers>
                <tr>
                  <th align="left" style="width: 15%;">Kategori</th>
                  <th align="left" style="width: 40%;">Tiltak</th>
                  <th align="left">Ansvarlig</th>
                  <th style="width:50px;"></th>
                </tr>
              </template>
              <template v-slot:items="props">
                <!-- <div>{{props.item}}</div> -->
                <tr>
                  <td>
                    <v-menu
                      v-model="props.item.kategori_meny"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ props.item.category || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="
                            props.item.category = item.category;
                            registeredchanges = true;
                          "
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.measure"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.responsibility"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td align="right">
                    <v-icon @click="fjern_aktivitet(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <th colspan="4">Legg til ny aktivitet</th>
                </tr>
                <tr>
                  <td>
                    <v-menu
                      v-model="newCategoryAvdAktivitetMeny"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ newCategoryAvdAktivitet || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="newCategoryAvdAktivitet = item.category"
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newMeasure"
                      label="Tiltak"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newResponsibility"
                      label="Ansvar"
                    ></v-text-field>
                  </td>
                  <td align="right">
                    <v-icon @click="legg_til_avd_aktivitet">add</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            Vernerunde
            <h1>
              Vernerundespørsmål
            </h1>
            <v-data-table :items="vernerunde_questions" hide-actions>
              <template v-slot:headers>
                <tr>
                  <th align="left" style="width: 15%;">Kategori</th>
                  <th align="left" style="width: 40%;">Spørsmål</th>
                  <th align="left">Positiv</th>
                  <th style="width:50px;"></th>
                </tr>
              </template>
              <template v-slot:items="props">
                <!-- <div>{{props.item}}</div> -->
                <tr>
                  <td>
                    <v-menu
                      v-model="props.item.kategori_meny"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ props.item.category || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="
                            props.item.category = item.category;
                            registeredchanges = true;
                          "
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.measure"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="props.item.responsibility"
                      @input="registeredchanges = true"
                    ></v-text-field>
                  </td>
                  <td align="right">
                    <v-icon @click="fjern_aktivitet(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <th colspan="4">Legg til nytt spørsmål</th>
                </tr>
                <tr>
                  <td>
                    <v-menu
                      v-model="newCategoryQuestion"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn block flat v-on="on">
                          {{ newCategoryQuestion || "Velg kategori" }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in plan.categories"
                          :key="index"
                          @click="newCategoryQuestion = item.category"
                        >
                          <v-list-tile-title>{{
                            item.category
                          }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newQuestionText"
                      label="Spørsmålstekst"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="newQuestionPositive"
                      label="positiv"
                    ></v-text-field>
                  </td>
                  
                  <td align="right">
                    <v-icon @click="submitQuestions">add</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab>Rapporter</v-tab>
      <v-tab-item class="mt-3">
        <v-tabs grow>
          <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_evaluering }}</v-tab>
          <v-tab>{{ GET_ORDLYD && GET_ORDLYD.main_obli_activities }}</v-tab>
          <v-tab>{{ GET_ORDLYD && GET_ORDLYD.main_ovrige_activities }}</v-tab>
          <v-tab ripple>{{GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities}}</v-tab>

          <v-tab-item> <!-- Evaluering -->
            <v-data-table
              :items="rapportevaluering"
              :expand="true"
              hide-actions
              :headers="rapportevalueringheaders"
            >
              <template v-slot:items="props">
                <tr :class="{ 'blue lighten-3': props.expanded }">
                  <td :class="{ 'display-1': props.expanded }">
                    {{ props.item.question }}
                  </td>
                  <td>{{ props.item.notanswered }}</td>
                  <td>{{ props.item.yes }}</td>
                  <td>{{ props.item.no }}</td>
                  <td>
                    <v-btn icon @click="props.expanded = !props.expanded">
                      <v-icon v-if="props.expanded">remove</v-icon>
                      <v-icon v-else>add</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card class="pl-3" color="blue lighten-3">
                  <!-- <v-container grid-list-md> -->
                  <!-- <v-layout align-start justify-space-between row fill-height wrap> -->
                  <template v-for="(sector, sectorindex) in plan.sectors">
                    <v-flex
                      xs12
                      v-for="(area, areaindex) in plan.areas.filter(
                        (el) => el.sector_id == sector.id
                      )"
                      :key="area.id"
                    >
                      <v-card
                        :class="{ 'mt-3': areaindex > 0 || sectorindex > 0 }"
                        flat
                      >
                        <v-card-title class="title"
                          >{{ sector.label }} - {{ area.label }}</v-card-title
                        >
                        <v-card-text>
                          <v-data-table
                            hide-actions
                            :items="
                              props.item.answers.filter(
                                (el) =>
                                  el.sector_label == sector.label &&
                                  el.area_label == area.label
                              )
                            "
                            :headers="rapportevalueringdetaljerheaders"
                          >
                            <template v-slot:items="props">
                              <tr
                                :class="{
                                  'green lighten-2': props.item.completed == 1,
                                  'red darken-1 grey--text text--lighten-3':
                                    props.item.completed == 2,
                                }"
                              >
                                <td>{{ props.item.avd_label }}</td>
                                <td width="200">
                                  {{ props.item.completed_label }}
                                </td>
                              </tr>
                              <tr v-if="props.item.text">
                                <td
                                  colspan="2"
                                  class="blue lighten-3 black--text font-weight-light font-italic pl-5"
                                >
                                  "{{ props.item.text }}"
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                  <!-- </v-layout> -->
                  <!-- </v-container> -->
                </v-card>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item> <!-- Obligatoriske aktiviteter-->
            <v-data-table
              :items="rapportoblaktiviteter"
              :expand="true"
              :headers="rapportoblaktiviteterheaders"
              hide-actions
            >
              <template v-slot:items="props">
                <tr
                  :class="{
                    'blue lighten-3': props.expanded,
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <td width="15%">{{ props.item.category }}</td>
                  <td width="40%">{{ props.item.measure }}</td>
                  <td width="20%">{{ props.item.responsibility }}</td>
                  <td width="20%">
                    {{ props.item.done }} / {{ props.item.totalanswers }}
                  </td>
                  <td>
                    <v-btn icon @click="props.expanded = !props.expanded">
                      <v-icon v-if="props.expanded">remove</v-icon>
                      <v-icon v-else>add</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card
                  class="pl-3"
                  color="blue lighten-3"
                  :class="{
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <template v-for="(sector, sectorindex) in plan.sectors">
                    <v-flex
                      xs12
                      v-for="(area, areaindex) in plan.areas.filter(
                        (el) => el.sector_id == sector.id
                      )"
                      :key="area.id"
                    >
                      <v-card
                        :class="{ 'mt-3': areaindex > 0 || sectorindex > 0 }"
                        flat
                      >
                        <v-card-title class="title"
                          >{{ sector.label }} - {{ area.label }}</v-card-title
                        >
                        <v-card-text>
                          <v-data-table
                            hide-actions
                            :items="
                              props.item.answers.filter(
                                (el) =>
                                  el.sector_label == sector.label &&
                                  el.area_label == area.label
                              )
                            "
                            :headers="rapportoblaktiviteterdetaljerheaders"
                          >
                            <template v-slot:items="props">
                              <tr>
                                <td width="33%">{{ props.item.avd_label }}</td>
                                <td width="33%">
                                  {{ props.item.schedule || "Ikke besvart" }}
                                </td>
                                <td>
                                  {{
                                    (props.item.done &&
                                      props.item.doneDate &&
                                      props.item.doneDate.slice(0, 10)) ||
                                      "Ikke utført"
                                  }}
                                </td>
                              </tr>
                              <tr v-if="props.item.text">
                                <td colspan="3" class="font-weight-bold pa-5">
                                  {{ props.item.text }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                </v-card>
              </template>
            </v-data-table>
          </v-tab-item>
          <!-- <v-tab-item>
            <v-data-table
              :items="rapportovrigeaktiviteter"
              :expand="true"
              :headers="rapportovrigeheaders"
            >
              <template v-slot:items="props">
                <tr
                  :class="{
                    'blue lighten-3': props.expanded,
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <td>{{ props.item.schedule }}</td>
                  <td>{{ props.item.category }}</td>
                  <td>{{ props.item.measure }}</td>
                  <td>{{ props.item.responsibility }}</td>
                  <td>
                    {{
                      (props.item.done &&
                        props.item.doneDate &&
                        props.item.doneDate.slice(0, 10)) ||
                        "Ikke utført"
                    }}
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <v-card
                  class="pl-3"
                  color="blue lighten-3"
                  :class="{
                    'green lighten-3':
                      props.item.done == props.item.totalanswers,
                  }"
                >
                  <template v-for="(sector, sectorindex) in plan.sectors">
                    <v-flex
                      xs12
                      v-for="(area, areaindex) in plan.areas.filter(
                        (el) => el.sector_id == sector.id
                      )"
                      :key="area.id"
                    >
                      <v-card
                        :class="{ 'mt-3': areaindex > 0 || sectorindex > 0 }"
                        flat
                      >
                        <v-card-title class="title"
                          >{{ sector.label }} - {{ area.label }}</v-card-title
                        >
                        <v-card-text>
                          <v-data-table
                            hide-actions
                            :items="
                              props.item.answers.filter(
                                (el) =>
                                  el.sector_label == sector.label &&
                                  el.area_label == area.label
                              )
                            "
                            :headers="rapportoblaktiviteterdetaljerheaders"
                          >
                            <template v-slot:items="props">
                              <tr>
                                <td width="33%">{{ props.item.avd_label }}</td>
                                <td width="33%">
                                  {{ props.item.schedule || "Ikke besvart" }}
                                </td>
                                <td>
                                  {{
                                    (props.item.done &&
                                      props.item.doneDate &&
                                      props.item.doneDate.slice(0, 10)) ||
                                      "Ikke utført"
                                  }}
                                </td>
                              </tr>
                              <tr v-if="props.item.text">
                                <td colspan="3" class="font-weight-bold pa-5">
                                  {{ props.item.text }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                </v-card>
              </template>
            </v-data-table>
          </v-tab-item> -->
          <v-tab-item> <!-- Øvrige aktiviteter -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="rapportOvrigeAktiviteter"
              :headers="rapportHeaders"
              :search="search"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                  <tr class="activities">
                    <td>{{ props.item.avd_label }}</td>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.brukAv }}</td>
                    <td>{{ props.item.responsibility }}</td>
                    <td>{{ props.item.doneDate }}</td>
                  </tr>
              </template>
            </v-data-table>
            <vue-excel-xlsx
                :data="rapportOvrigeAktiviteter"
                :columns="excelHeaders"
                :file-name="'filename'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                >
                <v-btn>
                  Eksporter
                </v-btn>
              </vue-excel-xlsx>
          </v-tab-item>
          <v-tab-item> <!-- BRUK AV BHT OG ALS -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :items="rapportBrukAvHmsOgAlsAktiviteter"
              :headers="rapportHeaders"
              :search="search"
              :must_sort="avdeling"
              :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                  <tr class="activities">
                    <td>{{ props.item.avd_label }}</td>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.brukAv }}</td>
                    <td>{{ props.item.responsibility }}</td>
                    <td>{{ props.item.doneDate }}</td>
                  </tr>
                </template>
              </v-data-table>
              <vue-excel-xlsx
                :data="rapportBrukAvHmsOgAlsAktiviteter"
                :columns="excelHeaders"
                :file-name="'filename'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                class="btn"
                >
                <v-btn>
                  Eksporter
                </v-btn>
              </vue-excel-xlsx>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card round>
        <v-card-text>
          {{ loadingDialogText }}
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div id="buttonwrapper" v-if="registeredchanges">
      <v-btn color="success" @click="submitEditPlan">Lagre</v-btn>
      <!-- <v-btn color="warning" @click="resetResponse">Avbryt</v-btn> -->
    </div>
  </v-container>
  <v-layout v-else fill-height column align-center justify-center>
    <v-alert :value="true" type="info">
      Vennligst vent mens vi henter data..
      <v-progress-linear
        indeterminate
        color="primary"
        class="mb-0"
      ></v-progress-linear>
    </v-alert>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import Doc from "./components/Doc.js";
import Title from "./components/Title.js";
import {
  Placeholder,
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  methods: {
    ...mapActions(["GET_PLAN", "ALTER_PLAN", "FETCH_ORDLYD", "GET_QUESTIONS", "ALTER_QUESTIONS",]),
    submitQuestions() {
      this.loadingDialogText = "Vennligst vent mens vi lagrer data";
      this.loadingDialog = true;
      let _newQuestion = {
        category: this.newCategoryQuestion,
        text: this.newTextQuestion,
        planningid: this.plan.planning["id"],
        positive: this.newQuestionPositive,
      };
      let _self = this;
      console.log('NEW QUESTION: ',_newQuestion)
      // _self
      //   .ALTER_QUESTIONS({
      //     planid: _newQuestion.id,
      //     Transfer: "createquestion",
      //     data: _newQuestion
      //   })
      //   .finally(() => {
      //     _self.loadingDialog = false;
      //     this.newCategoryQuestion = "";
      //     this.newTextQuestion = "";
      //     this.newQuestionPositive = "";
      //     _self.registeredchanges = false;
      //     _self.getQuestions();
      //   });
      _self.loadingDialog = false;
      _self.registeredchanges = false;
    },
    submitEditPlan() {
      this.loadingDialogText = "Vennligst vent mens vi lagrer data";
      this.loadingDialog = true;
      let _newPlan = {
        id: this.plan.planning["id"],
        title: this.planTitle,
        description: this.planEditors.planDescription.getHTML(),
        avd_maalsetting: this.planEditors.planAvdMaal.getHTML(),
        overordna_maalsetting: this.planEditors.planOverordnaMaal.getHTML(),
        veiledning: this.planEditors.planVeiledning.getHTML(),
        activities: this.plan.activities,
        evaluationtasks: this.plan.evaluationtasks,
        year: this.plan.planning["year"],
      };

      let _self = this;
      // setTimeout(() => {
      //   _self
      // }, 200);
      _self
        .ALTER_PLAN({
          planid: _newPlan.id,
          customerid: _self.GET_USER.customerid,
          Transfer: "editplan",
          data: _newPlan,
        })
        .finally(() => {
          _self.dialogAlterDepartment = false;
          _self.loadingDialog = false;
          _self.registeredchanges = false;
          _self.getPlan();
        });
    },
    deleteEvaluationTask(evt) {
      this.plan.evaluationtasks = this.plan.evaluationtasks.filter(
        (res) => res.id != evt.id
      );
      this.registeredchanges = true;
    },
    addEvaluationTask(evt) {
      this.plan.evaluationtasks.push({
        id: "tmp" + new Date().valueOf().toString(16),
        question: this.newEvaluation,
      });
      this.newEvaluation = "";
      this.registeredchanges = true;
    },
    legg_til_overordna_aktivitet() {
      let _insert = {
        id: "tmp" + new Date().valueOf().toString(16),
        schedule: this.newSchedule,
        measure: this.newMeasure,
        category: this.newCategoryOverordnaAktivitet,
        responsibility: this.newResponsibility,
        level: "kommune",
      };
      this.plan.activities.push(_insert);
      this.registeredchanges = true;
      this.newSchedule = "";
      this.newMeasure = "";
      this.category = "";
      this.newResponsibility = "";
    },
    fjern_aktivitet(aktivitet) {
      this.plan.activities = this.plan.activities.filter(
        (res) => res.id != aktivitet.id
      );
      this.registeredchanges = true;
    },
    legg_til_avd_aktivitet() {
      let _insert = {
        id: "tmp" + new Date().valueOf().toString(16),
        measure: this.newMeasure,
        responsibility: this.newResponsibility,
        category: this.newCategoryAvdAktivitet,
        level: "avdeling",
      };
      this.plan.activities.push(_insert);
      this.registeredchanges = true;
      this.newMeasure = "";
      this.newResponsibility = "";
    },
    getQuestions() {
      return "Success";
    },
    getPlan() {
      this.loadingDialogText = "Vennligst vent mens vi henter data";
      this.loadingDialog = true;
      this.GET_PLAN(this.$route.params.guid)
        .then((res) => {
          this.loadingDialog = false;
          this.plan = res.data;
          //console.log('plan:', this.plan)
          this.plan.activities.forEach((element) => {
            element.kategori_meny = false;
          });
          this.planDataIsRetrieved = true;
          // this.planEditors.planTitle.setContent(this.plan.planning[0]["title"]);
          this.planTitle = this.plan.planning["title"];
          this.planEditors.planDescription.setContent(
            this.plan.planning["description"]
          );
          this.planEditors.planOverordnaMaal.setContent(
            this.plan.planning["overordna_maalsetting"]
          );
          this.planEditors.planAvdMaal.setContent(
            this.plan.planning["avd_maalsetting"]
          );
          this.planEditors.planVeiledning.setContent(
            this.plan.planning["veiledning"]
          );
          this.registeredchanges = false;
          this.rapportoblaktiviteter = this.setrapportoblaktiviteter();
          //this.rapportovrigeaktiviteter = this.setrapportovrigeaktiviteter();
          //this.rapportbrukavhmsogalsaktiviteter = this.setrapportbrukavhmsogalsaktiviteter();
          this.rapportevaluering = this.setrapportevaluering();
          this.rapportOvrigeAktiviteter = this.setRapportOvrigeAktiviteter();
          this.rapportBrukAvHmsOgAlsAktiviteter = this.setRapportBrukAvHmsOgAlsAktiviteter();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    setRapportBrukAvHmsOgAlsAktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.bruk_av_hms_og_als_activities
        .filter((activity) => activity.planningid == this.plan.planning.id && activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
        .forEach((el) => {
          _thisRapportOverview.push(el);
        });
      return _thisRapportOverview;
    },

    setRapportOvrigeAktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.ovrige_activities
        .filter((activity) => activity.planningid == this.plan.planning.id && activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
        .forEach((el) => {
          _thisRapportOverview.push(el)
        });
        return _thisRapportOverview
    },

    setrapportevaluering() {
      let _thisRapportOverview = [];
      this.plan.reports.evaluation
      .filter((evaluation) => evaluation.sector_label !== "Å Avdelinger ikke lenger i bruk")
      .forEach((el) => {
        if (
          _thisRapportOverview.filter((ro) => ro.id == el.evaluation_id)
            .length == 0
        ) {
          _thisRapportOverview.push({
            id: el.evaluation_id,
            question: el.evaluation_question,
            notanswered: 0,
            yes: 0,
            no: 0,
          });
        }
      });
      _thisRapportOverview.forEach((ro) => {
        ro.answers = this.plan.reports.evaluation
          .filter((el) => el.evaluation_id == ro.id && el.sector_label !== "Å Avdelinger ikke lenger i bruk")
          .map((el) => {
            return {
              avd_label: el.avd_label,
              sector_label: el.sector_label,
              area_label: el.area_label,
              text: el.text,
              completed: el.completed,
              completed_label:
                el.completed == 2
                  ? "Nei"
                  : el.completed == 1
                  ? "Ja"
                  : "Ikke besvart",
            };
          });

        ro.notanswered = ro.answers.filter((el) => !el.completed).length;
        ro.yes = ro.answers.filter((el) => el.completed == 1).length;
        ro.no = ro.answers.filter((el) => el.completed == 2).length;
      });
      return _thisRapportOverview;
    },
    setrapportoblaktiviteter() {
      let _thisRapportOverview = [];
      this.plan.reports.obl_activities
      .filter((activity) => activity.sector_label !== "Å Avdelinger ikke lenger i bruk")
      .forEach((el) => {
        if (
          _thisRapportOverview.filter((ro) => ro.id == el.mainid).length == 0
        ) {
          _thisRapportOverview.push({
            id: el.mainid,
            schedule: el.mainschedule,
            measure: el.mainmeasure,
            category: el.maincategory,
            responsibility: el.mainresponsibility,
            done: 0,
          });
        }
      });
      _thisRapportOverview.forEach((ro) => {
        ro.answers = this.plan.reports.obl_activities
          .filter((el) => el.mainid == ro.id && el.sector_label !== "Å Avdelinger ikke lenger i bruk")
          .map((el) => {
            return {
              avd_label: el.avd_label,
              sector_label: el.sector_label,
              area_label: el.area_label,
              schedule: el.schedule,
              done: el.done,
              doneDate: el.doneDate,
            };
          });

        ro.done = ro.answers.filter((el) => !!el.doneDate).length;
        ro.totalanswers = ro.answers.length;
      });
      let _thisCategories = [];
      _thisRapportOverview.forEach((el) => {
        if (
          _thisCategories.filter(
            (_thisCategory) => _thisCategory.label == el.category
          ).length == 0
        ) {
          _thisCategories.push({
            label: el.category,
            active: true,
            sort: _thisCategories.length + 1,
          });
        }
      });
      this.rapportoblaktiviteter_categories = _thisCategories;
      return _thisRapportOverview;
    },
  },
  data() {
    return {
      search: '', //Enables searching on data-tables
      pagination: {
        rowsPerPage: 25
      },

      maanedsvalg: [
        "Månedlig",
        "Jevnlig",
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      loadingDialog: false,
      loadingDialogText: "",
      registeredchanges: false,
      planDataIsRetrieved: false,
      plan: {},
      planTitle: "",
      planDescription: "",
      planOverordnaMaal: "",
      planAvdMaal: "",
      planVeiledning: "",
      newEvaluation: "",
      newSchedule: "",
      newMeasure: "",
      newResponsibility: "",
      newCategoryOverordnaAktivitet: "",
      newCategoryOverordnaAktivitetMeny: "",
      newCategoryObligatoriskAktivitetMeny: "",
      newCategoryObligatoriskAktivitet: "",
      newCategoryAvdAktivitet: "",
      newCategoryAvdAktivitetMeny: "",
      // Vernerunde
      questions: [],
      newVernerundeQuestion: "",
      newVernerundeMeny: "",
      newCategoryQuestion: "",
      newQuestionText: "",
      newQuestionPositive: 0,

      planEditors: {
        planDescription: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planOverordnaMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planAvdMaal: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
        planVeiledning: new Editor({
          extensions: [
            new Bold(),
            new Heading({ levels: [1, 2, 3] }),
            new BulletList(),
            new OrderedList(),
            new ListItem(),
            new TodoItem(),
            new TodoList(),
            new History(),
          ],
          editable: true,
          content: ``,
          onUpdate: () => {
            this.registeredchanges = true;
          },
        }),
      },
      rapportevalueringheaders: [
        { text: "Spørsmål", value: "question" },
        { text: "Ikke besvart", value: "notanswered" },
        { text: "Ja", value: "yes" },
        { text: "Nei", value: "no" },
        { text: "Se/skjul detaljer", value: "", sortable: false },
      ],
      rapportevalueringdetaljerheaders: [
        { text: "Avdeling", value: "avd_label" },
        { text: "Utført", value: "completed_label" },
      ],
      rapportoblaktiviteterheaders: [
        { text: "Kategori", value: "category" },
        { text: "Tiltak", value: "measure" },
        { text: "Ansvarlig", value: "responsibility" },
        { text: "Utført/Totalt", value: "" },
        { text: "Se/skjul detaljer", value: "", sortable: false },
      ],
      rapportoblaktiviteterdetaljerheaders: [
        { text: "Avdeling", value: "avd_label" },
        { text: "Tidsplan", value: "schedule" },
        { text: "Utført", value: "doneDate" },
      // eslint-disable-next-line prettier/prettier
      ],
      rapportovrigeheaders: [
        { text: "Tidsplan", value: "schedule" },
        { text: "Kategori", value: "category" },
        { text: "Tiltak", value: "measure" },
        { text: "Ansvarlig", value: "responsibility" },
        { text: "Utført", value: "completed_label" },
      ],
      sektorHeaders: [
        {text: "Sektor", value: "label"},
        {text: "Antall aktiviteter", value: "areaActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "areaActivities.done"}
      ],
      områdeHeaders: [
        {text: "Område", value: "label"},
        {text: "Antall aktiviteter", value: "orgActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "orgActivities.done"}
      ],
      avdelingHeaders: [
        {text: "Avdeling", value: "label"},
        {text: "Antall aktiviteter", value: "numActivities.total"},
        {text: "Gjennomførte aktiviteter", value: "numActivities.done"}
      ],
      rapportHeaders: [
        {text: "Avdeling", value: "avd_label"},
        {text: "Tidsplan", value: "schedule"},
        {text: "Kategori", value: "category"},
        {text: "Tiltak", value: "measure"},
        {text: "Bruk av", value: "brukAv"},
        {text: "Ansvarlig", value: "responsibility"},
        {text: "Utført", value: "doneDate"}
      ],
      excelHeaders: [
        {label: "Avdeling", field: "avd_label"},
        {label: "Tidsplan", field: "schedule"},
        {label: "Kategori", field: "category"},
        {label: "Tiltak", field: "measure"},
        {label: "Bruk av", field: "brukAv"},
        {label: "Ansvarlig", field: "responsibility"},
        {label: "Utført", field: "doneDate"}
      ],

      rapportevaluering: [],
      rapportoblaktiviteter_categories: [],
      rapportoblaktiviteter: [],
      rapportovrigeaktiviteter_categories: [],
      rapportOvrigeAktiviteter: [],
      //rapportovrigeaktiviteter: [],
      rapportbrukavhmsogalsaktiviteter_categories: [],
      //rapportbrukavhmsogalsaktiviteter: [],
      rapportBrukAvHmsOgAlsAktiviteter: [],
      // rapportTesting: [],
    };
  },
  computed: {
    ...mapGetters(["GET_USER", "GET_ORDLYD"]),
    overordna_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "kommune");
    },
    avd_aktivitet() {
      return this.plan.activities.filter((res) => res.level == "avdeling");
    },
    computedOvrigeActivities() {
    let total = this.rapportovrigeaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.total;
    }, 0);
    let done = this.rapportovrigeaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.done;
    }, 0);
    
    return `Totalt: ${total} Gjennomførte: ${done}`;
  },
  computedStotteActivities() {
    let total = this.rapportbrukavhmsogalsaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.total;
    }, 0);
    let done = this.rapportbrukavhmsogalsaktiviteter.reduce((acc, val) => {
      return acc + val.areaActivities.done;
    }, 0);
    
    return `Totalt: ${total} Gjennomførte: ${done}`;
  },
  },
  mounted() {
    this.getPlan();
  },
  beforeDestroy() {
    this.planEditors.planDescription.destroy();
    this.planEditors.planOverordnaMaal.destroy();
    this.planEditors.planAvdMaal.destroy();
    this.planEditors.planVeiledning.destroy();
  },
  beforeRouteLeave(to, from, next) {
    if (this.registeredchanges) {
      const answer = window.confirm(
        "Er du sikker på at du ønsker å forlate siden? Du har endringer som ikke er lagret."
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

};
</script>

<style>

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 2rem;
  background-color: transparent;
}

#thead tr th {
  background-color: #f5f5f5;
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.activities {

}

.activities:nth-child(odd) {
    background-color: #cccccc;
  }

.ProseMirror {
  background-color: rgba(0, 0, 0, 0.06);
  padding: 20px 10px;
}
.is-hidden {
  visibility: hidden;
}
.is-hidden.is-focused {
  visibility: visible;
}
</style>
